module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "secondary-sidebar padding-30"
  }, [_c('a', {
    staticClass: "btn btn-complete btn-block btn-compose m-b-30",
    attrs: {
      "href": "email_compose.html"
    }
  }, [_vm._v("Compose")]), _vm._v(" "), _c('p', {
    staticClass: "menu-title"
  }, [_vm._v("BROWSE")]), _vm._v(" "), _c('ul', {
    staticClass: "main-menu"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "pg-inbox"
  }), _vm._v(" Inbox")]), _vm._v(" "), _c('span', {
    staticClass: "badge pull-right"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "pg-folder"
  }), _vm._v(" All mail")])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu no-padding"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Important")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Labeled")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "pg-sent"
  }), _vm._v(" Sent")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "pg-spam"
  }), _vm._v(" Spam")]), _vm._v(" "), _c('span', {
    staticClass: "badge pull-right"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "menu-title m-t-20 all-caps"
  }, [_vm._v("Quick view")]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu no-padding"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Documents")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Flagged")]), _vm._v(" "), _c('span', {
    staticClass: "badge pull-right"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Images")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f0128e9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sidebar.vue
// module id = 1283
// module chunks = 1